export default __webpack_public_path__ + "vectors/direction-mob.svg?56e5ceab";